var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("扫码开启2024年度报告")]),_c('div',{staticClass:"qrcode-wrapper"},[_c('img',{attrs:{"src":"https://i.boatonland.com/report2024/assets/qrcode.png"}})])])
}]

export { render, staticRenderFns }